import styled from "styled-components";
import ArrowBackImgDark from "../assets/Vector.png";
import ArrowBackImgLight from "../assets/arrow-back-white.svg";
import { Link } from "react-router-dom";

const ArrowBack = styled.img`
  cursor: pointer;
  width: 36px;
  height: 27px;
  margin-top: ${(props) => props.marginTop || "40px"};
  margin-left: 70px;
`;

const BackNavigation = ({ mode, url, marginTop }) => {
  return (
    <Link to={-1}>
      <ArrowBack
        src={mode === "dark" ? ArrowBackImgDark : ArrowBackImgLight}
        marginTop={marginTop}
      />
    </Link>
  );
};

export default BackNavigation;
